module.exports = __webpack_public_path__ + "media/images/cleveland-clinic-b99c2882c93ab95365f38b3e001b86d8.gif";